import { IPostLoginActions, TLoginWarning } from "./login.model";
import { useDisclosure } from "@mantine/hooks";
import { useEffect, useMemo } from "react";
import { Anchor, Modal, Text } from "@mantine/core";
import { getOrigin } from "../../../environment";
import { Button } from "../Button/Button";
import { ButtonsWrapper, Flex } from "../../../styled";

interface Props {
  warningData: TLoginWarning;
  setWarningData: (data: TLoginWarning) => void;
  onConfirm: (data: IPostLoginActions) => void;
}

const LoginWarningModal = ({
  warningData,
  setWarningData,
  onConfirm,
}: Props) => {
  const [opened, { open, close }] = useDisclosure(false);

  useEffect(() => {
    if (warningData) open();
  }, [warningData]);

  const handleClose = () => {
    close();
    if (!warningData?.denied) onConfirm(warningData as any);

    setTimeout(() => setWarningData(null), 300);
  };

  const paragraphs = useMemo(() => {
    if (!warningData?.message) return [];
    const paragraphs = warningData.message.split(".").filter(p => p.trim());
    return paragraphs.map((paragraph, index) => (
      <Text key={index} align="center" color={index === 0 ? "red" : undefined}>
        {paragraph}.
      </Text>
    ));
  }, [warningData]);

  const getFilenameFromUrl = (url: string) => {
    if (!url) return "";
    const parts = url.split("/");
    return parts[parts.length - 1];
  };

  return (
    <Modal
      opened={opened}
      onClose={handleClose}
      title={!warningData?.denied && "Warning"}>
      <Text align="center">{paragraphs}</Text>

      <Flex justify="center" w="100%" mt={10}>
        {warningData?.link && (
          <Anchor
            href={warningData.link}
            download={getFilenameFromUrl(warningData.link)}
            onClick={e => {}} // do not remove click handler
            target="_blank"
            color="green.6"
            style={{ textDecoration: "underline", fontWeight: 200 }}>
            Install the latest desktop app
          </Anchor>
        )}
      </Flex>

      {!warningData?.denied && (
        <Flex justify="center" w="100%" mt={20}>
          <Button onClick={handleClose}>Continue</Button>
        </Flex>
      )}
    </Modal>
  );
};

export default LoginWarningModal;
